import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AppShell } from '../components/layout/AppShell';
import { ContractForm } from '../components/contracts/ContractForm';
import { useCreateContract } from '../hooks/useContracts';
import { markFormSaved } from '../hooks/useUnsavedChanges';
import { apiErrorMessage } from '../lib/api-error-message';
import { useToastHelpers } from '../components/ui';
import type { CreateContractInput, UpdateContractInput } from '@armard/shared';

export const Route = createFileRoute('/contracts_/new')({
  validateSearch: z.object({ customerId: z.string().uuid().optional() }),
  component: NewContractPage,
});

function NewContractPage() {
  const navigate = useNavigate();
  const toast = useToastHelpers();
  const createContract = useCreateContract();
  const { customerId } = Route.useSearch();

  const save = async (values: CreateContractInput | UpdateContractInput) => {
    try {
      const contract = await createContract.mutateAsync(values as CreateContractInput);
      markFormSaved();
      toast.success('Vertrag erstellt');
      await navigate({ to: '/contracts/$id', params: { id: contract.id } });
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Fehler beim Erstellen des Vertrags'));
    }
  };

  return (
    <ProtectedRoute>
      <AppShell>
        <ContractForm
          initialCustomerId={customerId}
          title="Neuer Vertrag"
          submitLabel="Vertrag erstellen"
          isSaving={createContract.isPending}
          onCancel={() => navigate({ to: '/contracts' })}
          onSave={save}
        />
      </AppShell>
    </ProtectedRoute>
  );
}
